import data from '../../../../data/country/country_gdp.json';
import "../../../../css/layout/sidebar.css";

const SidebarAllCountryList  = ({path}) => {
    
    const rows = [];

    for(let i in data){
        if(i=="Country"){continue;}
        rows.push(<div className='sidebar-page-list-div'>
                <a href={path+"/"+i} style={{padding:0}}>
                    <h5 className='sidebar-page-list-div-link' >{i}</h5>
                </a>
            </div>);
    }

    return (
        <div className="sidebar-page-list" style={{opacity: 1}}>
            {rows}
        </div>
    );

}

export default SidebarAllCountryList;